// libraries.
import { monserratSemiBold } from "@habitech/shared";
import styled from "styled-components";

export const Title = styled.div`
  font-family: ${monserratSemiBold};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;
